import { Pipe, PipeTransform } from '@angular/core';
import {
  PlanAttributes,
  SummaryView
} from '../interfaces/plan-attributes.interface';
import { Product } from '../interfaces/product.interface';

@Pipe({
    name: 'price',
    standalone: false
})
export class PricePipe implements PipeTransform {
  transform(
    items: Product<PlanAttributes, SummaryView>[],
    low: number,
    high: number
  ): Product<PlanAttributes, SummaryView>[] {
    if (Number.isInteger(low) && Number.isInteger(high) && items?.length > 0) {
      return items.filter((item: Product<PlanAttributes, SummaryView>) => {
        const price: number = parseInt(item.price as string, 10);
        return price >= low && price <= high;
      });
    }
    return items;

  }
}
